/**
 * https://tailwindcss.com/docs/screens
 * Based on tailwind default breakpoints
 */
export const BREAKPOINT_S = 640;
export const BREAKPOINT_M = 768;
export const BREAKPOINT_L = 1024;
export const BREAKPOINT_XL = 1280;
export const BREAKPOINT_XXL = 1536;

/** Max width */
export const BREAKPOINT_MAX_MOBILE = BREAKPOINT_M - 1;
export const BREAKPOINT_MAX_TABLET = BREAKPOINT_L - 1;

/** Min width */
export const BREAKPOINT_MIN_TABLET = BREAKPOINT_M;
export const BREAKPOINT_MIN_DESKTOP = BREAKPOINT_L;

/**
 * Other resources around breakpoints
 */

/**
 * https://polypane.app/blog/css-breakpoints-used-by-popular-css-frameworks/
 */

/**
 * https://devfacts.com/media-queries-breakpoints-2021/
 * Widths
 *
 * Mobile
 *  Portrait: 320 ~ 414
 *  Landscape: 568 ~ 812
 * Tablet:
 *  Portrait: 768 ~ 834
 *  Landscape: 1024 ~ 1112
 * Laptop: 1366 ~ 1440
 * Desktop: 1680 ~ 1920
 */

/**
 * https://kinsta.com/blog/responsive-web-design/
 *
 * Min widths
 *
 * Mobile: 576
 * Tablets: 768
 * Laptops: 992
 * Large Devices: 1200
 *
 */
